/* eslint-disable guard-for-in */
import { format, parse } from 'date-fns';
import * as React from 'react';
import { NavigateFunction } from 'react-router';
import { UploadFileInfo } from '@progress/kendo-react-upload';
import Customer from '../models/be/Customer';
import Option from '../models/Option';
import { Logo } from '../models/be/Branding';
import { countryIsUk } from '../config.local';
import vettingLogoPng from '../images/vetting-logo.png';
import ReportWorkflows from '../models/be/ReportWorkflows';
import { countryCodeMap } from '../core/countryList';

export const CountryCodeNum = {
	usCode: '+1',
	caCode: '+1',
	auCode: '+61',
	nzCode: '+64',
	sgCode: '+65',
	ukCode: '+44',
	deCode: '+49',
	afCode: '+93',
	alCode: '+355',
	dzCode: '+213',
	asCode: '+1-684',
	adCode: '+376',
	aoCode: '+244',
	aiCode: '+1-264',
	aqCode: '+672',
	agCode: '+1-268',
	arCode: '+54',
	amCode: '+374',
	awCode: '+297',
	atCode: '+43',
	azCode: '+994',
	bsCode: '+1-242',
	bhCode: '+973',
	bdCode: '+880',
	bbCode: '+1-246',
	byCode: '+375',
	beCode: '+32',
	bzCode: '+501',
	bjCode: '+229',
	bmCode: '+1-441',
	btCode: '+975',
	boCode: '+591',
	baCode: '+387',
	bwCode: '+267',
	brCode: '+55',
	ioCode: '+246',
	vgCode: '+1-284',
	bnCode: '+673',
	bgCode: '+359',
	bfCode: '+226',
	biCode: '+257',
	khCode: '+855',
	cmCode: '+237',
	cvCode: '+238',
	kyCode: '+1-345',
	cfCode: '+236',
	tdCode: '+235',
	clCode: '+56',
	cnCode: '+86',
	coCode: '+57',
	kmCode: '+269',
	ckCode: '+682',
	crCode: '+506',
	hrCode: '+385',
	cuCode: '+53',
	cyCode: '+357',
	czCode: '+420',
	cdCode: '+243',
	dkCode: '+45',
	djCode: '+253',
	dmCode: '+1-767',
	doCode1: '+1-809',
	doCode2: '1-829',
	doCode3: '1-849',
	tlCode: '+670',
	ecCode: '+593',
	egCode: '+20',
	svCode: '+503',
	gqCode: '+240',
	erCode: '+291',
	eeCode: '+372',
	etCode: '+251',
	fkCode: '+500',
	foCode: '+298',
	fjCode: '+679',
	fiCode: '+358',
	frCode: '+33',
	pfCode: '+689',
	gaCode: '+241',
	gmCode: '+220',
	geCode: '+995',
	ghCode: '+233',
	giCode: '+350',
	grCode: '+30',
	glCode: '+299',
	gdCode: '+1-473',
	guCode: '+1-671',
	gtCode: '+502',
	ggCode: '+44-1481',
	gnCode: '+224',
	gwCode: '+245',
	gyCode: '+592',
	htCode: '+509',
	hnCode: '+504',
	hkCode: '+852',
	huCode: '+36',
	isCode: '+354',
	inCode: '+91',
	idCode: '+62',
	irCode: '+98',
	iqCode: '+964',
	ieCode: '+353',
	imCode: '+44-1624',
	ilCode: '+972',
	itCode: '+39',
	ciCode: '+225',
	jmCode: '+1-876',
	jpCode: '+81',
	jeCode: '+44-1534',
	joCode: '+962',
	keCode: '+254',
	kiCode: '+686',
	xkCode: '+383',
	kwCode: '+965',
	kgCode: '+996',
	laCode: '+856',
	lvCode: '+371',
	lbCode: '+961',
	lsCode: '+266',
	lrCode: '+231',
	lyCode: '+218',
	liCode: '+423',
	ltCode: '+370',
	luCode: '+352',
	moCode: '+853',
	mkCode: '+389',
	mgCode: '+261',
	mwCode: '+265',
	myCode: '+60',
	mvCode: '+960',
	mlCode: '+223',
	mtCode: '+356',
	mhCode: '+692',
	mrCode: '+222',
	muCode: '+230',
	mxCode: '+52',
	fmCode: '+691',
	mdCode: '+373',
	mcCode: '+377',
	mnCode: '+976',
	meCode: '+382',
	msCode: '+1-664',
	maCode: '+212',
	mzCode: '+258',
	mmCode: '+95',
	naCode: '+264',
	nrCode: '+674',
	npCode: '+977',
	nlCode: '+31',
	anCode: '+599',
	ncCode: '+687',
	niCode: '+505',
	neCode: '+227',
	ngCode: '+234',
	nuCode: '+683',
	kpCode: '+850',
	mpCode: '+1-670',
	noCode: '+47',
	omCode: '+968',
	pkCode: '+92',
	pwCode: '+680',
	psCode: '+970',
	paCode: '+507',
	pgCode: '+675',
	pyCode: '+595',
	peCode: '+51',
	phCode: '+63',
	plCode: '+48',
	ptCode: '+351',
	prCode1: '+1-787',
	prCode2: '1-939',
	qaCode: '+974',
	cgCode: '+242',
	reCode: '+262',
	roCode: '+40',
	ruCode: '+7',
	kzCode: '+7',
	rwCode: '+250',
	shCode: '+290',
	knCode: '+1-869',
	lcCode: '+1-758',
	mfCode: '+590',
	pmCode: '+508',
	vcCode: '+1-784',
	wsCode: '+685',
	smCode: '+378',
	stCode: '+239',
	saCode: '+966',
	snCode: '+221',
	rsCode: '+381',
	scCode: '+248',
	slCode: '+232',
	sxCode: '+1-721',
	skCode: '+421',
	siCode: '+386',
	sbCode: '+677',
	soCode: '+252',
	zaCode: '+27',
	krCode: '+82',
	ssCode: '+211',
	esCode: '+34',
	lkCode: '+94',
	sdCode: '+249',
	srCode: '+597',
	szCode: '+268',
	seCode: '+46',
	chCode: '+41',
	syCode: '+963',
	twCode: '+886',
	tjCode: '+992',
	tzCode: '+255',
	thCode: '+66',
	tgCode: '+228',
	tkCode: '+690',
	toCode: '+676',
	ttCode: '+1-868',
	tnCode: '+216',
	trCode: '+90',
	tmCode: '+993',
	tcCode: '+1-649',
	tvCode: '+688',
	viCode: '+1-340',
	ugCode: '+256',
	uaCode: '+380',
	aeCode: '+971',
	uyCode: '+598',
	uzCode: '+998',
	vuCode: '+678',
	vaCode: '+379',
	veCode: '+58',
	vnCode: '+84',
	wfCode: '+681',
	yeCode: '+967',
	zmCode: '+260',
	zwCode: '+263'
};

export const OldCountryCode = {
	usCode: 'US',
	auCode: 'AU',
	nzCode: 'NZ',
	sgCode: 'SG',
	ukCode: 'UK',
	deCode: 'DE'
};

export const OldCountryCodeNumArray = ['+1', '+61', '+64', '+65', '+44', '+49'];

export const CountryCode = {
	usCode: 'US',
	caCode: 'CA',
	auCode: 'AU',
	nzCode: 'NZ',
	sgCode: 'SG',
	ukCode: 'UK',
	deCode: 'DE',
	afCode: 'AF',
	alCode: 'AL',
	dzCode: 'DZ',
	asCode: 'AS',
	adCode: 'AD',
	aoCode: 'AO',
	aiCode: 'AI',
	aqCode: 'AQ',
	agCode: 'AG',
	arCode: 'AR',
	amCode: 'AM',
	awCode: 'AW',
	atCode: 'AT',
	azCode: 'AZ',
	bsCode: 'BS',
	bhCode: 'BH',
	bdCode: 'BD',
	bbCode: 'BB',
	byCode: 'BY',
	beCode: 'BE',
	bzCode: 'BZ',
	bjCode: 'BJ',
	bmCode: 'BM',
	btCode: 'BT',
	boCode: 'BO',
	baCode: 'BA',
	bwCode: 'BW',
	brCode: 'BR',
	ioCode: 'IO',
	vgCode: 'VG',
	bnCode: 'BN',
	bgCode: 'BG',
	bfCode: 'BF',
	biCode: 'BI',
	khCode: 'KH',
	cmCode: 'CM',
	cvCode: 'CV',
	kyCode: 'KY',
	cfCode: 'CF',
	tdCode: 'TD',
	clCode: 'CL',
	cnCode: 'CN',
	coCode: 'CO',
	kmCode: 'KM',
	ckCode: 'CK',
	crCode: 'CR',
	hrCode: 'HR',
	cuCode: 'CU',
	cyCode: 'CY',
	czCode: 'CZ',
	cdCode: 'CD',
	dkCode: 'DK',
	djCode: 'DJ',
	dmCode: 'DM',
	doCode1: 'DO1',
	doCode2: 'DO2',
	doCode3: 'DO3',
	tlCode: 'TL',
	ecCode: 'EC',
	egCode: 'EG',
	svCode: 'SV',
	gqCode: 'GQ',
	erCode: 'ER',
	eeCode: 'EE',
	etCode: 'ET',
	fkCode: 'FK',
	foCode: 'FO',
	fjCode: 'FJ',
	fiCode: 'FI',
	frCode: 'FR',
	pfCode: 'PF',
	gaCode: 'GA',
	gmCode: 'GM',
	geCode: 'GE',
	ghCode: 'GH',
	giCode: 'GI',
	grCode: 'GR',
	glCode: 'GL',
	gdCode: 'GD',
	guCode: 'GU',
	gtCode: 'GT',
	ggCode: 'GG',
	gnCode: 'GN',
	gwCode: 'GW',
	gyCode: 'GY',
	htCode: 'HT',
	hnCode: 'HN',
	hkCode: 'HK',
	huCode: 'HU',
	isCode: 'IS',
	inCode: 'IN',
	idCode: 'ID',
	irCode: 'IR',
	iqCode: 'IQ',
	ieCode: 'IE',
	imCode: 'IM',
	ilCode: 'IL',
	itCode: 'IT',
	ciCode: 'CI',
	jmCode: 'JM',
	jpCode: 'JP',
	jeCode: 'JE',
	joCode: 'JO',
	keCode: 'KE',
	kiCode: 'KI',
	xkCode: 'XK',
	kwCode: 'KW',
	kgCode: 'KG',
	laCode: 'LA',
	lvCode: 'LV',
	lbCode: 'LB',
	lsCode: 'LS',
	lrCode: 'LR',
	lyCode: 'LY',
	liCode: 'LI',
	ltCode: 'LT',
	luCode: 'LU',
	moCode: 'MO',
	mkCode: 'MK',
	mgCode: 'MG',
	mwCode: 'MW',
	myCode: 'MY',
	mvCode: 'MV',
	mlCode: 'ML',
	mtCode: 'MT',
	mhCode: 'MH',
	mrCode: 'MR',
	muCode: 'MU',
	mxCode: 'MX',
	fmCode: 'FM',
	mdCode: 'MD',
	mcCode: 'MC',
	mnCode: 'MN',
	meCode: 'ME',
	msCode: 'MS',
	maCode: 'MA',
	mzCode: 'MZ',
	mmCode: 'MM',
	naCode: 'NA',
	nrCode: 'NR',
	npCode: 'NP',
	nlCode: 'NL',
	anCode: 'AN',
	ncCode: 'NC',
	niCode: 'NI',
	neCode: 'NE',
	ngCode: 'NG',
	nuCode: 'NU',
	kpCode: 'KP',
	mpCode: 'MP',
	noCode: 'NO',
	omCode: 'OM',
	pkCode: 'PK',
	pwCode: 'PW',
	psCode: 'PS',
	paCode: 'PA',
	pgCode: 'PG',
	pyCode: 'PY',
	peCode: 'PE',
	phCode: 'PH',
	plCode: 'PL',
	ptCode: 'PT',
	prCode1: 'PR1',
	prCode2: 'PR2',
	qaCode: 'QA',
	cgCode: 'CG',
	reCode: 'RE',
	roCode: 'RO',
	ruCode: 'RU',
	kzCode: 'KZ',
	rwCode: 'RW',
	shCode: 'SH',
	knCode: 'KN',
	lcCode: 'LC',
	mfCode: 'MF',
	pmCode: 'PM',
	vcCode: 'VC',
	wsCode: 'WS',
	smCode: 'SM',
	stCode: 'ST',
	saCode: 'SA',
	snCode: 'SN',
	rsCode: 'RS',
	scCode: 'SC',
	slCode: 'SL',
	sxCode: 'SX',
	skCode: 'SK',
	siCode: 'SI',
	sbCode: 'SB',
	soCode: 'SO',
	zaCode: 'ZA',
	krCode: 'KR',
	ssCode: 'SS',
	esCode: 'ES',
	lkCode: 'LK',
	sdCode: 'SD',
	srCode: 'SR',
	szCode: 'SZ',
	seCode: 'SE',
	chCode: 'CH',
	syCode: 'SY',
	twCode: 'TW',
	tjCode: 'TJ',
	tzCode: 'TZ',
	thCode: 'TH',
	tgCode: 'TG',
	tkCode: 'TK',
	toCode: 'TO',
	ttCode: 'TT',
	tnCode: 'TN',
	trCode: 'TR',
	tmCode: 'TM',
	tcCode: 'TC',
	tvCode: 'TV',
	viCode: 'VI',
	ugCode: 'UG',
	uaCode: 'UA',
	aeCode: 'AE',
	uyCode: 'UY',
	uzCode: 'UZ',
	vuCode: 'VU',
	vaCode: 'VA',
	veCode: 'VE',
	vnCode: 'VN',
	wfCode: 'WF',
	yeCode: 'YE',
	zmCode: 'ZM',
	zwCode: 'ZW'
};

export const CountryCodeNumArray = [
	'+1',
	'+61',
	'+64',
	'+65',
	'+44',
	'+49',
	'+93',
	'+355',
	'+213',
	'+1-684',
	'+376',
	'+244',
	'+1-264',
	'+672',
	'+1-268',
	'+54',
	'+374',
	'+297',
	'+43',
	'+994',
	'+1-242',
	'+973',
	'+880',
	'+1-246',
	'+375',
	'+32',
	'+501',
	'+229',
	'+1-441',
	'+975',
	'+591',
	'+387',
	'+267',
	'+55',
	'+246',
	'+1-284',
	'+673',
	'+359',
	'+226',
	'+257',
	'+855',
	'+237',
	'+238',
	'+1-345',
	'+236',
	'+235',
	'+56',
	'+86',
	'+61',
	'+61',
	'+57',
	'+269',
	'+682',
	'+506',
	'+385',
	'+53',
	'+357',
	'+420',
	'+243',
	'+45',
	'+253',
	'+1-767',
	'+1-809',
	'+1-829',
	'+1-849',
	'+670',
	'+593',
	'+20',
	'+503',
	'+240',
	'+291',
	'+372',
	'+251',
	'+500',
	'+298',
	'+679',
	'+358',
	'+33',
	'+689',
	'+241',
	'+220',
	'+995',
	'+233',
	'+350',
	'+30',
	'+299',
	'+1-473',
	'+1-671',
	'+502',
	'+44-1481',
	'+224',
	'+245',
	'+592',
	'+509',
	'+504',
	'+852',
	'+36',
	'+354',
	'+91',
	'+62',
	'+98',
	'+964',
	'+353',
	'+44-1624',
	'+972',
	'+39',
	'+225',
	'+1-876',
	'+81',
	'+44-1534',
	'+962',
	'+254',
	'+686',
	'+383',
	'+965',
	'+996',
	'+856',
	'+371',
	'+961',
	'+266',
	'+231',
	'+218',
	'+423',
	'+370',
	'+352',
	'+853',
	'+389',
	'+261',
	'+265',
	'+60',
	'+960',
	'+223',
	'+356',
	'+692',
	'+222',
	'+230',
	'+52',
	'+691',
	'+373',
	'+377',
	'+976',
	'+382',
	'+1-664',
	'+212',
	'+258',
	'+95',
	'+264',
	'+674',
	'+977',
	'+31',
	'+599',
	'+687',
	'+505',
	'+227',
	'+234',
	'+683',
	'+850',
	'+1-670',
	'+47',
	'+968',
	'+92',
	'+680',
	'+970',
	'+507',
	'+675',
	'+595',
	'+51',
	'+63',
	'+48',
	'+351',
	'+1-787',
	'+1-939',
	'+974',
	'+242',
	'+262',
	'+40',
	'+7',
	'+250',
	'+290',
	'+1-869',
	'+1-758',
	'+590',
	'+508',
	'+1-784',
	'+685',
	'+378',
	'+239',
	'+966',
	'+221',
	'+381',
	'+248',
	'+232',
	'+1-721',
	'+421',
	'+386',
	'+677',
	'+252',
	'+27',
	'+82',
	'+211',
	'+34',
	'+94',
	'+249',
	'+597',
	'+268',
	'+46',
	'+41',
	'+963',
	'+886',
	'+992',
	'+255',
	'+66',
	'+228',
	'+690',
	'+676',
	'+1-868',
	'+216',
	'+90',
	'+993',
	'+1-649',
	'+688',
	'+1-340',
	'+256',
	'+380',
	'+971',
	'+598',
	'+998',
	'+678',
	'+379',
	'+58',
	'+84',
	'+681',
	'+967',
	'+260',
	'+263'
];

export const countryCodesToMobileNumberLengths = {
	// does not contain  a leading zero.
	[CountryCode.usCode]: 10,
	[CountryCode.caCode]: 10,
	[CountryCode.auCode]: 9,
	[CountryCode.nzCode]: 9,
	[CountryCode.sgCode]: 8,
	[CountryCode.ukCode]: 10,
	[CountryCode.deCode]: 10,
	[CountryCode.afCode]: 12,
	[CountryCode.alCode]: 12,
	[CountryCode.dzCode]: 12,
	[CountryCode.asCode]: 12,
	[CountryCode.adCode]: 12,
	[CountryCode.aoCode]: 12,
	[CountryCode.aiCode]: 12,
	[CountryCode.aqCode]: 12,
	[CountryCode.agCode]: 12,
	[CountryCode.arCode]: 12,
	[CountryCode.amCode]: 12,
	[CountryCode.awCode]: 12,
	[CountryCode.atCode]: 12,
	[CountryCode.azCode]: 12,
	[CountryCode.bsCode]: 12,
	[CountryCode.bhCode]: 12,
	[CountryCode.bdCode]: 12,
	[CountryCode.bbCode]: 12,
	[CountryCode.byCode]: 12,
	[CountryCode.beCode]: 12,
	[CountryCode.bzCode]: 12,
	[CountryCode.bjCode]: 12,
	[CountryCode.bmCode]: 12,
	[CountryCode.btCode]: 12,
	[CountryCode.boCode]: 12,
	[CountryCode.baCode]: 12,
	[CountryCode.bwCode]: 12,
	[CountryCode.brCode]: 12,
	[CountryCode.ioCode]: 12,
	[CountryCode.vgCode]: 12,
	[CountryCode.bnCode]: 12,
	[CountryCode.bgCode]: 12,
	[CountryCode.bfCode]: 12,
	[CountryCode.biCode]: 12,
	[CountryCode.khCode]: 12,
	[CountryCode.cmCode]: 12,
	[CountryCode.cvCode]: 12,
	[CountryCode.kyCode]: 12,
	[CountryCode.cfCode]: 12,
	[CountryCode.tdCode]: 12,
	[CountryCode.clCode]: 12,
	[CountryCode.cnCode]: 12,
	[CountryCode.coCode]: 12,
	[CountryCode.kmCode]: 12,
	[CountryCode.ckCode]: 12,
	[CountryCode.crCode]: 12,
	[CountryCode.hrCode]: 12,
	[CountryCode.cuCode]: 12,
	[CountryCode.cyCode]: 12,
	[CountryCode.czCode]: 12,
	[CountryCode.cdCode]: 12,
	[CountryCode.dkCode]: 12,
	[CountryCode.djCode]: 12,
	[CountryCode.dmCode]: 12,
	[CountryCode.doCode1]: 12,
	[CountryCode.doCode2]: 12,
	[CountryCode.doCode3]: 12,
	[CountryCode.tlCode]: 12,
	[CountryCode.ecCode]: 12,
	[CountryCode.egCode]: 12,
	[CountryCode.svCode]: 12,
	[CountryCode.gqCode]: 12,
	[CountryCode.erCode]: 12,
	[CountryCode.eeCode]: 12,
	[CountryCode.etCode]: 12,
	[CountryCode.fkCode]: 12,
	[CountryCode.foCode]: 12,
	[CountryCode.fjCode]: 12,
	[CountryCode.fiCode]: 12,
	[CountryCode.frCode]: 12,
	[CountryCode.pfCode]: 12,
	[CountryCode.gaCode]: 12,
	[CountryCode.gmCode]: 12,
	[CountryCode.geCode]: 12,
	[CountryCode.ghCode]: 12,
	[CountryCode.giCode]: 12,
	[CountryCode.grCode]: 12,
	[CountryCode.glCode]: 12,
	[CountryCode.gdCode]: 12,
	[CountryCode.guCode]: 12,
	[CountryCode.gtCode]: 12,
	[CountryCode.ggCode]: 12,
	[CountryCode.gnCode]: 12,
	[CountryCode.gwCode]: 12,
	[CountryCode.gyCode]: 12,
	[CountryCode.htCode]: 12,
	[CountryCode.hnCode]: 12,
	[CountryCode.hkCode]: 12,
	[CountryCode.huCode]: 12,
	[CountryCode.isCode]: 12,
	[CountryCode.inCode]: 12,
	[CountryCode.idCode]: 12,
	[CountryCode.irCode]: 12,
	[CountryCode.iqCode]: 12,
	[CountryCode.ieCode]: 12,
	[CountryCode.imCode]: 12,
	[CountryCode.ilCode]: 12,
	[CountryCode.itCode]: 12,
	[CountryCode.ciCode]: 12,
	[CountryCode.jmCode]: 12,
	[CountryCode.jpCode]: 12,
	[CountryCode.jeCode]: 12,
	[CountryCode.joCode]: 12,
	[CountryCode.keCode]: 12,
	[CountryCode.kiCode]: 12,
	[CountryCode.xkCode]: 12,
	[CountryCode.kwCode]: 12,
	[CountryCode.kgCode]: 12,
	[CountryCode.laCode]: 12,
	[CountryCode.lvCode]: 12,
	[CountryCode.lbCode]: 12,
	[CountryCode.lsCode]: 12,
	[CountryCode.lrCode]: 12,
	[CountryCode.lyCode]: 12,
	[CountryCode.liCode]: 12,
	[CountryCode.ltCode]: 12,
	[CountryCode.luCode]: 12,
	[CountryCode.moCode]: 12,
	[CountryCode.mkCode]: 12,
	[CountryCode.mgCode]: 12,
	[CountryCode.mwCode]: 12,
	[CountryCode.myCode]: 12,
	[CountryCode.mvCode]: 12,
	[CountryCode.mlCode]: 12,
	[CountryCode.mtCode]: 12,
	[CountryCode.mhCode]: 12,
	[CountryCode.mrCode]: 12,
	[CountryCode.muCode]: 12,
	[CountryCode.mxCode]: 12,
	[CountryCode.fmCode]: 12,
	[CountryCode.mdCode]: 12,
	[CountryCode.mcCode]: 12,
	[CountryCode.mnCode]: 12,
	[CountryCode.meCode]: 12,
	[CountryCode.msCode]: 12,
	[CountryCode.maCode]: 12,
	[CountryCode.mzCode]: 12,
	[CountryCode.mmCode]: 12,
	[CountryCode.naCode]: 12,
	[CountryCode.nrCode]: 12,
	[CountryCode.npCode]: 12,
	[CountryCode.nlCode]: 12,
	[CountryCode.anCode]: 12,
	[CountryCode.ncCode]: 12,
	[CountryCode.niCode]: 12,
	[CountryCode.neCode]: 12,
	[CountryCode.ngCode]: 12,
	[CountryCode.nuCode]: 12,
	[CountryCode.kpCode]: 12,
	[CountryCode.mpCode]: 12,
	[CountryCode.noCode]: 12,
	[CountryCode.omCode]: 12,
	[CountryCode.pkCode]: 12,
	[CountryCode.pwCode]: 12,
	[CountryCode.psCode]: 12,
	[CountryCode.paCode]: 12,
	[CountryCode.pgCode]: 12,
	[CountryCode.pyCode]: 12,
	[CountryCode.peCode]: 12,
	[CountryCode.phCode]: 12,
	[CountryCode.plCode]: 12,
	[CountryCode.ptCode]: 12,
	[CountryCode.prCode1]: 12,
	[CountryCode.prCode2]: 12,
	[CountryCode.qaCode]: 12,
	[CountryCode.cgCode]: 12,
	[CountryCode.reCode]: 12,
	[CountryCode.roCode]: 12,
	[CountryCode.ruCode]: 12,
	[CountryCode.rwCode]: 12,
	[CountryCode.shCode]: 12,
	[CountryCode.knCode]: 12,
	[CountryCode.lcCode]: 12,
	[CountryCode.mfCode]: 12,
	[CountryCode.pmCode]: 12,
	[CountryCode.vcCode]: 12,
	[CountryCode.wsCode]: 12,
	[CountryCode.smCode]: 12,
	[CountryCode.stCode]: 12,
	[CountryCode.saCode]: 12,
	[CountryCode.snCode]: 12,
	[CountryCode.rsCode]: 12,
	[CountryCode.scCode]: 12,
	[CountryCode.slCode]: 12,
	[CountryCode.sxCode]: 12,
	[CountryCode.skCode]: 12,
	[CountryCode.siCode]: 12,
	[CountryCode.sbCode]: 12,
	[CountryCode.soCode]: 12,
	[CountryCode.zaCode]: 12,
	[CountryCode.krCode]: 12,
	[CountryCode.ssCode]: 12,
	[CountryCode.esCode]: 12,
	[CountryCode.lkCode]: 12,
	[CountryCode.sdCode]: 12,
	[CountryCode.srCode]: 12,
	[CountryCode.szCode]: 12,
	[CountryCode.seCode]: 12,
	[CountryCode.chCode]: 12,
	[CountryCode.syCode]: 12,
	[CountryCode.twCode]: 12,
	[CountryCode.tjCode]: 12,
	[CountryCode.tzCode]: 12,
	[CountryCode.thCode]: 12,
	[CountryCode.tgCode]: 12,
	[CountryCode.tkCode]: 12,
	[CountryCode.toCode]: 12,
	[CountryCode.ttCode]: 12,
	[CountryCode.tnCode]: 12,
	[CountryCode.trCode]: 12,
	[CountryCode.tmCode]: 12,
	[CountryCode.tcCode]: 12,
	[CountryCode.tvCode]: 12,
	[CountryCode.viCode]: 12,
	[CountryCode.ugCode]: 12,
	[CountryCode.uaCode]: 12,
	[CountryCode.aeCode]: 12,
	[CountryCode.uyCode]: 12,
	[CountryCode.uzCode]: 12,
	[CountryCode.vuCode]: 12,
	[CountryCode.vaCode]: 12,
	[CountryCode.veCode]: 12,
	[CountryCode.vnCode]: 12,
	[CountryCode.wfCode]: 12,
	[CountryCode.yeCode]: 12,
	[CountryCode.zmCode]: 12,
	[CountryCode.zwCode]: 12
};

export const countryCodeNumsToCountryCodes = {
	[CountryCodeNum.usCode]: 'US',
	[CountryCodeNum.auCode]: 'AU',
	[CountryCodeNum.nzCode]: 'NZ',
	[CountryCodeNum.sgCode]: 'SG',
	[CountryCodeNum.ukCode]: 'UK',
	[CountryCodeNum.deCode]: 'DE',
	[CountryCodeNum.afCode]: 'AF',
	[CountryCodeNum.alCode]: 'AL',
	[CountryCodeNum.dzCode]: 'DZ',
	[CountryCodeNum.asCode]: 'AS',
	[CountryCodeNum.adCode]: 'AD',
	[CountryCodeNum.aoCode]: 'AO',
	[CountryCodeNum.aiCode]: 'AI',
	[CountryCodeNum.aqCode]: 'AQ',
	[CountryCodeNum.agCode]: 'AG',
	[CountryCodeNum.arCode]: 'AR',
	[CountryCodeNum.amCode]: 'AM',
	[CountryCodeNum.awCode]: 'AW',
	[CountryCodeNum.atCode]: 'AT',
	[CountryCodeNum.azCode]: 'AZ',
	[CountryCodeNum.bsCode]: 'BS',
	[CountryCodeNum.bhCode]: 'BH',
	[CountryCodeNum.bdCode]: 'BD',
	[CountryCodeNum.bbCode]: 'BB',
	[CountryCodeNum.byCode]: 'BY',
	[CountryCodeNum.beCode]: 'BE',
	[CountryCodeNum.bzCode]: 'BZ',
	[CountryCodeNum.bjCode]: 'BJ',
	[CountryCodeNum.bmCode]: 'BM',
	[CountryCodeNum.btCode]: 'BT',
	[CountryCodeNum.boCode]: 'BO',
	[CountryCodeNum.baCode]: 'BA',
	[CountryCodeNum.bwCode]: 'BW',
	[CountryCodeNum.brCode]: 'BR',
	[CountryCodeNum.ioCode]: 'IO',
	[CountryCodeNum.vgCode]: 'VG',
	[CountryCodeNum.bnCode]: 'BN',
	[CountryCodeNum.bgCode]: 'BG',
	[CountryCodeNum.bfCode]: 'BF',
	[CountryCodeNum.biCode]: 'BI',
	[CountryCodeNum.khCode]: 'KH',
	[CountryCodeNum.cmCode]: 'CM',
	[CountryCodeNum.cvCode]: 'CV',
	[CountryCodeNum.kyCode]: 'KY',
	[CountryCodeNum.cfCode]: 'CF',
	[CountryCodeNum.tdCode]: 'TD',
	[CountryCodeNum.clCode]: 'CL',
	[CountryCodeNum.cnCode]: 'CN',
	[CountryCodeNum.coCode]: 'CO',
	[CountryCodeNum.kmCode]: 'KM',
	[CountryCodeNum.ckCode]: 'CK',
	[CountryCodeNum.crCode]: 'CR',
	[CountryCodeNum.hrCode]: 'HR',
	[CountryCodeNum.cuCode]: 'CU',
	[CountryCodeNum.cyCode]: 'CY',
	[CountryCodeNum.czCode]: 'CZ',
	[CountryCodeNum.cdCode]: 'CD',
	[CountryCodeNum.dkCode]: 'DK',
	[CountryCodeNum.djCode]: 'DJ',
	[CountryCodeNum.dmCode]: 'DM',
	[CountryCodeNum.doCode1]: 'DO',
	[CountryCodeNum.doCode2]: 'DO',
	[CountryCodeNum.doCode3]: 'DO',
	[CountryCodeNum.tlCode]: 'TL',
	[CountryCodeNum.ecCode]: 'EC',
	[CountryCodeNum.egCode]: 'EG',
	[CountryCodeNum.svCode]: 'SV',
	[CountryCodeNum.gqCode]: 'GQ',
	[CountryCodeNum.erCode]: 'ER',
	[CountryCodeNum.eeCode]: 'EE',
	[CountryCodeNum.etCode]: 'ET',
	[CountryCodeNum.fkCode]: 'FK',
	[CountryCodeNum.foCode]: 'FO',
	[CountryCodeNum.fjCode]: 'FJ',
	[CountryCodeNum.fiCode]: 'FI',
	[CountryCodeNum.frCode]: 'FR',
	[CountryCodeNum.pfCode]: 'PF',
	[CountryCodeNum.gaCode]: 'GA',
	[CountryCodeNum.gmCode]: 'GM',
	[CountryCodeNum.geCode]: 'GE',
	[CountryCodeNum.ghCode]: 'GH',
	[CountryCodeNum.giCode]: 'GI',
	[CountryCodeNum.grCode]: 'GR',
	[CountryCodeNum.glCode]: 'GL',
	[CountryCodeNum.gdCode]: 'GD',
	[CountryCodeNum.guCode]: 'GU',
	[CountryCodeNum.gtCode]: 'GT',
	[CountryCodeNum.ggCode]: 'GG',
	[CountryCodeNum.gnCode]: 'GN',
	[CountryCodeNum.gwCode]: 'GW',
	[CountryCodeNum.gyCode]: 'GY',
	[CountryCodeNum.htCode]: 'HT',
	[CountryCodeNum.hnCode]: 'HN',
	[CountryCodeNum.hkCode]: 'HK',
	[CountryCodeNum.huCode]: 'HU',
	[CountryCodeNum.isCode]: 'IS',
	[CountryCodeNum.inCode]: 'IN',
	[CountryCodeNum.idCode]: 'ID',
	[CountryCodeNum.irCode]: 'IR',
	[CountryCodeNum.iqCode]: 'IQ',
	[CountryCodeNum.ieCode]: 'IE',
	[CountryCodeNum.imCode]: 'IM',
	[CountryCodeNum.ilCode]: 'IL',
	[CountryCodeNum.itCode]: 'IT',
	[CountryCodeNum.ciCode]: 'CI',
	[CountryCodeNum.jmCode]: 'JM',
	[CountryCodeNum.jpCode]: 'JP',
	[CountryCodeNum.jeCode]: 'JE',
	[CountryCodeNum.joCode]: 'JO',
	[CountryCodeNum.keCode]: 'KE',
	[CountryCodeNum.kiCode]: 'KI',
	[CountryCodeNum.xkCode]: 'XK',
	[CountryCodeNum.kwCode]: 'KW',
	[CountryCodeNum.kgCode]: 'KG',
	[CountryCodeNum.laCode]: 'LA',
	[CountryCodeNum.lvCode]: 'LV',
	[CountryCodeNum.lbCode]: 'LB',
	[CountryCodeNum.lsCode]: 'LS',
	[CountryCodeNum.lrCode]: 'LR',
	[CountryCodeNum.lyCode]: 'LY',
	[CountryCodeNum.liCode]: 'LI',
	[CountryCodeNum.ltCode]: 'LT',
	[CountryCodeNum.luCode]: 'LU',
	[CountryCodeNum.moCode]: 'MO',
	[CountryCodeNum.mkCode]: 'MK',
	[CountryCodeNum.mgCode]: 'MG',
	[CountryCodeNum.mwCode]: 'MW',
	[CountryCodeNum.myCode]: 'MY',
	[CountryCodeNum.mvCode]: 'MV',
	[CountryCodeNum.mlCode]: 'ML',
	[CountryCodeNum.mtCode]: 'MT',
	[CountryCodeNum.mhCode]: 'MH',
	[CountryCodeNum.mrCode]: 'MR',
	[CountryCodeNum.muCode]: 'MU',
	[CountryCodeNum.mxCode]: 'MX',
	[CountryCodeNum.fmCode]: 'FM',
	[CountryCodeNum.mdCode]: 'MD',
	[CountryCodeNum.mcCode]: 'MC',
	[CountryCodeNum.mnCode]: 'MN',
	[CountryCodeNum.meCode]: 'ME',
	[CountryCodeNum.msCode]: 'MS',
	[CountryCodeNum.maCode]: 'MA',
	[CountryCodeNum.mzCode]: 'MZ',
	[CountryCodeNum.mmCode]: 'MM',
	[CountryCodeNum.naCode]: 'NA',
	[CountryCodeNum.nrCode]: 'NR',
	[CountryCodeNum.npCode]: 'NP',
	[CountryCodeNum.nlCode]: 'NL',
	[CountryCodeNum.anCode]: 'AN',
	[CountryCodeNum.ncCode]: 'NC',
	[CountryCodeNum.niCode]: 'NI',
	[CountryCodeNum.neCode]: 'NE',
	[CountryCodeNum.ngCode]: 'NG',
	[CountryCodeNum.nuCode]: 'NU',
	[CountryCodeNum.kpCode]: 'KP',
	[CountryCodeNum.mpCode]: 'MP',
	[CountryCodeNum.noCode]: 'NO',
	[CountryCodeNum.omCode]: 'OM',
	[CountryCodeNum.pkCode]: 'PK',
	[CountryCodeNum.pwCode]: 'PW',
	[CountryCodeNum.psCode]: 'PS',
	[CountryCodeNum.paCode]: 'PA',
	[CountryCodeNum.pgCode]: 'PG',
	[CountryCodeNum.pyCode]: 'PY',
	[CountryCodeNum.peCode]: 'PE',
	[CountryCodeNum.phCode]: 'PH',
	[CountryCodeNum.plCode]: 'PL',
	[CountryCodeNum.ptCode]: 'PT',
	[CountryCodeNum.prCode1]: 'PR',
	[CountryCodeNum.prCode2]: 'PR',
	[CountryCodeNum.qaCode]: 'QA',
	[CountryCodeNum.cgCode]: 'CG',
	[CountryCodeNum.reCode]: 'RE',
	[CountryCodeNum.roCode]: 'RO',
	[CountryCodeNum.ruCode]: 'RU/KZ',
	[CountryCodeNum.rwCode]: 'RW',
	[CountryCodeNum.shCode]: 'SH',
	[CountryCodeNum.knCode]: 'KN',
	[CountryCodeNum.lcCode]: 'LC',
	[CountryCodeNum.mfCode]: 'MF',
	[CountryCodeNum.pmCode]: 'PM',
	[CountryCodeNum.vcCode]: 'VC',
	[CountryCodeNum.wsCode]: 'WS',
	[CountryCodeNum.smCode]: 'SM',
	[CountryCodeNum.stCode]: 'ST',
	[CountryCodeNum.saCode]: 'SA',
	[CountryCodeNum.snCode]: 'SN',
	[CountryCodeNum.rsCode]: 'RS',
	[CountryCodeNum.scCode]: 'SC',
	[CountryCodeNum.slCode]: 'SL',
	[CountryCodeNum.sxCode]: 'SX',
	[CountryCodeNum.skCode]: 'SK',
	[CountryCodeNum.siCode]: 'SI',
	[CountryCodeNum.sbCode]: 'SB',
	[CountryCodeNum.soCode]: 'SO',
	[CountryCodeNum.zaCode]: 'ZA',
	[CountryCodeNum.krCode]: 'KR',
	[CountryCodeNum.ssCode]: 'SS',
	[CountryCodeNum.esCode]: 'ES',
	[CountryCodeNum.lkCode]: 'LK',
	[CountryCodeNum.sdCode]: 'SD',
	[CountryCodeNum.srCode]: 'SR',
	[CountryCodeNum.szCode]: 'SZ',
	[CountryCodeNum.seCode]: 'SE',
	[CountryCodeNum.chCode]: 'CH',
	[CountryCodeNum.syCode]: 'SY',
	[CountryCodeNum.twCode]: 'TW',
	[CountryCodeNum.tjCode]: 'TJ',
	[CountryCodeNum.tzCode]: 'TZ',
	[CountryCodeNum.thCode]: 'TH',
	[CountryCodeNum.tgCode]: 'TG',
	[CountryCodeNum.tkCode]: 'TK',
	[CountryCodeNum.toCode]: 'TO',
	[CountryCodeNum.ttCode]: 'TT',
	[CountryCodeNum.tnCode]: 'TN',
	[CountryCodeNum.trCode]: 'TR',
	[CountryCodeNum.tmCode]: 'TM',
	[CountryCodeNum.tcCode]: 'TC',
	[CountryCodeNum.tvCode]: 'TV',
	[CountryCodeNum.viCode]: 'VI',
	[CountryCodeNum.ugCode]: 'UG',
	[CountryCodeNum.uaCode]: 'UA',
	[CountryCodeNum.aeCode]: 'AE',
	[CountryCodeNum.uyCode]: 'UY',
	[CountryCodeNum.uzCode]: 'UZ',
	[CountryCodeNum.vuCode]: 'VU',
	[CountryCodeNum.vaCode]: 'VA',
	[CountryCodeNum.veCode]: 'VE',
	[CountryCodeNum.vnCode]: 'VN',
	[CountryCodeNum.wfCode]: 'WF',
	[CountryCodeNum.yeCode]: 'YE',
	[CountryCodeNum.zmCode]: 'ZM',
	[CountryCodeNum.zwCode]: 'ZW'
};

export const countryCodesToCountryCodeNums = {
	[CountryCode.usCode]: CountryCodeNum.usCode,
	[CountryCode.caCode]: CountryCodeNum.caCode,
	[CountryCode.auCode]: CountryCodeNum.auCode,
	[CountryCode.nzCode]: CountryCodeNum.nzCode,
	[CountryCode.sgCode]: CountryCodeNum.sgCode,
	[CountryCode.ukCode]: CountryCodeNum.ukCode,
	[CountryCode.deCode]: CountryCodeNum.deCode,
	[CountryCode.afCode]: CountryCodeNum.afCode,
	[CountryCode.alCode]: CountryCodeNum.alCode,
	[CountryCode.dzCode]: CountryCodeNum.dzCode,
	[CountryCode.asCode]: CountryCodeNum.asCode,
	[CountryCode.adCode]: CountryCodeNum.adCode,
	[CountryCode.aoCode]: CountryCodeNum.aoCode,
	[CountryCode.aiCode]: CountryCodeNum.aiCode,
	[CountryCode.aqCode]: CountryCodeNum.aqCode,
	[CountryCode.agCode]: CountryCodeNum.agCode,
	[CountryCode.arCode]: CountryCodeNum.arCode,
	[CountryCode.amCode]: CountryCodeNum.amCode,
	[CountryCode.awCode]: CountryCodeNum.awCode,
	[CountryCode.atCode]: CountryCodeNum.atCode,
	[CountryCode.azCode]: CountryCodeNum.azCode,
	[CountryCode.bsCode]: CountryCodeNum.bsCode,
	[CountryCode.bhCode]: CountryCodeNum.bhCode,
	[CountryCode.bdCode]: CountryCodeNum.bdCode,
	[CountryCode.bbCode]: CountryCodeNum.bbCode,
	[CountryCode.byCode]: CountryCodeNum.byCode,
	[CountryCode.beCode]: CountryCodeNum.beCode,
	[CountryCode.bzCode]: CountryCodeNum.bzCode,
	[CountryCode.bjCode]: CountryCodeNum.bjCode,
	[CountryCode.bmCode]: CountryCodeNum.bmCode,
	[CountryCode.btCode]: CountryCodeNum.btCode,
	[CountryCode.boCode]: CountryCodeNum.boCode,
	[CountryCode.baCode]: CountryCodeNum.baCode,
	[CountryCode.bwCode]: CountryCodeNum.bwCode,
	[CountryCode.brCode]: CountryCodeNum.brCode,
	[CountryCode.ioCode]: CountryCodeNum.ioCode,
	[CountryCode.vgCode]: CountryCodeNum.vgCode,
	[CountryCode.bnCode]: CountryCodeNum.bnCode,
	[CountryCode.bgCode]: CountryCodeNum.bgCode,
	[CountryCode.bfCode]: CountryCodeNum.bfCode,
	[CountryCode.biCode]: CountryCodeNum.biCode,
	[CountryCode.khCode]: CountryCodeNum.khCode,
	[CountryCode.cmCode]: CountryCodeNum.cmCode,
	[CountryCode.cvCode]: CountryCodeNum.cvCode,
	[CountryCode.kyCode]: CountryCodeNum.kyCode,
	[CountryCode.cfCode]: CountryCodeNum.cfCode,
	[CountryCode.tdCode]: CountryCodeNum.tdCode,
	[CountryCode.clCode]: CountryCodeNum.clCode,
	[CountryCode.cnCode]: CountryCodeNum.cnCode,
	[CountryCode.coCode]: CountryCodeNum.coCode,
	[CountryCode.kmCode]: CountryCodeNum.kmCode,
	[CountryCode.ckCode]: CountryCodeNum.ckCode,
	[CountryCode.crCode]: CountryCodeNum.crCode,
	[CountryCode.hrCode]: CountryCodeNum.hrCode,
	[CountryCode.cuCode]: CountryCodeNum.cuCode,
	[CountryCode.cyCode]: CountryCodeNum.cyCode,
	[CountryCode.czCode]: CountryCodeNum.czCode,
	[CountryCode.cdCode]: CountryCodeNum.cdCode,
	[CountryCode.dkCode]: CountryCodeNum.dkCode,
	[CountryCode.djCode]: CountryCodeNum.djCode,
	[CountryCode.dmCode]: CountryCodeNum.dmCode,
	[CountryCode.doCode1]: CountryCodeNum.doCode1,
	[CountryCode.doCode2]: CountryCodeNum.doCode2,
	[CountryCode.doCode3]: CountryCodeNum.doCode3,
	[CountryCode.tlCode]: CountryCodeNum.tlCode,
	[CountryCode.ecCode]: CountryCodeNum.ecCode,
	[CountryCode.egCode]: CountryCodeNum.egCode,
	[CountryCode.svCode]: CountryCodeNum.svCode,
	[CountryCode.gqCode]: CountryCodeNum.gqCode,
	[CountryCode.erCode]: CountryCodeNum.erCode,
	[CountryCode.eeCode]: CountryCodeNum.eeCode,
	[CountryCode.etCode]: CountryCodeNum.etCode,
	[CountryCode.fkCode]: CountryCodeNum.fkCode,
	[CountryCode.foCode]: CountryCodeNum.foCode,
	[CountryCode.fjCode]: CountryCodeNum.fjCode,
	[CountryCode.fiCode]: CountryCodeNum.fiCode,
	[CountryCode.frCode]: CountryCodeNum.frCode,
	[CountryCode.pfCode]: CountryCodeNum.pfCode,
	[CountryCode.gaCode]: CountryCodeNum.gaCode,
	[CountryCode.gmCode]: CountryCodeNum.gmCode,
	[CountryCode.geCode]: CountryCodeNum.geCode,
	[CountryCode.ghCode]: CountryCodeNum.ghCode,
	[CountryCode.giCode]: CountryCodeNum.giCode,
	[CountryCode.grCode]: CountryCodeNum.grCode,
	[CountryCode.glCode]: CountryCodeNum.glCode,
	[CountryCode.gdCode]: CountryCodeNum.gdCode,
	[CountryCode.guCode]: CountryCodeNum.guCode,
	[CountryCode.gtCode]: CountryCodeNum.gtCode,
	[CountryCode.ggCode]: CountryCodeNum.ggCode,
	[CountryCode.gnCode]: CountryCodeNum.gnCode,
	[CountryCode.gwCode]: CountryCodeNum.gwCode,
	[CountryCode.gyCode]: CountryCodeNum.gyCode,
	[CountryCode.htCode]: CountryCodeNum.htCode,
	[CountryCode.hnCode]: CountryCodeNum.hnCode,
	[CountryCode.hkCode]: CountryCodeNum.hkCode,
	[CountryCode.huCode]: CountryCodeNum.huCode,
	[CountryCode.isCode]: CountryCodeNum.isCode,
	[CountryCode.inCode]: CountryCodeNum.inCode,
	[CountryCode.idCode]: CountryCodeNum.idCode,
	[CountryCode.irCode]: CountryCodeNum.irCode,
	[CountryCode.iqCode]: CountryCodeNum.iqCode,
	[CountryCode.ieCode]: CountryCodeNum.ieCode,
	[CountryCode.imCode]: CountryCodeNum.imCode,
	[CountryCode.ilCode]: CountryCodeNum.ilCode,
	[CountryCode.itCode]: CountryCodeNum.itCode,
	[CountryCode.ciCode]: CountryCodeNum.ciCode,
	[CountryCode.jmCode]: CountryCodeNum.jmCode,
	[CountryCode.jpCode]: CountryCodeNum.jpCode,
	[CountryCode.jeCode]: CountryCodeNum.jeCode,
	[CountryCode.joCode]: CountryCodeNum.joCode,
	[CountryCode.keCode]: CountryCodeNum.keCode,
	[CountryCode.kiCode]: CountryCodeNum.kiCode,
	[CountryCode.xkCode]: CountryCodeNum.xkCode,
	[CountryCode.kwCode]: CountryCodeNum.kwCode,
	[CountryCode.kgCode]: CountryCodeNum.kgCode,
	[CountryCode.laCode]: CountryCodeNum.laCode,
	[CountryCode.lvCode]: CountryCodeNum.lvCode,
	[CountryCode.lbCode]: CountryCodeNum.lbCode,
	[CountryCode.lsCode]: CountryCodeNum.lsCode,
	[CountryCode.lrCode]: CountryCodeNum.lrCode,
	[CountryCode.lyCode]: CountryCodeNum.lyCode,
	[CountryCode.liCode]: CountryCodeNum.liCode,
	[CountryCode.ltCode]: CountryCodeNum.ltCode,
	[CountryCode.luCode]: CountryCodeNum.luCode,
	[CountryCode.moCode]: CountryCodeNum.moCode,
	[CountryCode.mkCode]: CountryCodeNum.mkCode,
	[CountryCode.mgCode]: CountryCodeNum.mgCode,
	[CountryCode.mwCode]: CountryCodeNum.mwCode,
	[CountryCode.myCode]: CountryCodeNum.myCode,
	[CountryCode.mvCode]: CountryCodeNum.mvCode,
	[CountryCode.mlCode]: CountryCodeNum.mlCode,
	[CountryCode.mtCode]: CountryCodeNum.mtCode,
	[CountryCode.mhCode]: CountryCodeNum.mhCode,
	[CountryCode.mrCode]: CountryCodeNum.mrCode,
	[CountryCode.muCode]: CountryCodeNum.muCode,
	[CountryCode.mxCode]: CountryCodeNum.mxCode,
	[CountryCode.fmCode]: CountryCodeNum.fmCode,
	[CountryCode.mdCode]: CountryCodeNum.mdCode,
	[CountryCode.mcCode]: CountryCodeNum.mcCode,
	[CountryCode.mnCode]: CountryCodeNum.mnCode,
	[CountryCode.meCode]: CountryCodeNum.meCode,
	[CountryCode.msCode]: CountryCodeNum.msCode,
	[CountryCode.maCode]: CountryCodeNum.maCode,
	[CountryCode.mzCode]: CountryCodeNum.mzCode,
	[CountryCode.mmCode]: CountryCodeNum.mmCode,
	[CountryCode.naCode]: CountryCodeNum.naCode,
	[CountryCode.nrCode]: CountryCodeNum.nrCode,
	[CountryCode.npCode]: CountryCodeNum.npCode,
	[CountryCode.nlCode]: CountryCodeNum.nlCode,
	[CountryCode.anCode]: CountryCodeNum.anCode,
	[CountryCode.ncCode]: CountryCodeNum.ncCode,
	[CountryCode.niCode]: CountryCodeNum.niCode,
	[CountryCode.neCode]: CountryCodeNum.neCode,
	[CountryCode.ngCode]: CountryCodeNum.ngCode,
	[CountryCode.nuCode]: CountryCodeNum.nuCode,
	[CountryCode.kpCode]: CountryCodeNum.kpCode,
	[CountryCode.mpCode]: CountryCodeNum.mpCode,
	[CountryCode.noCode]: CountryCodeNum.noCode,
	[CountryCode.omCode]: CountryCodeNum.omCode,
	[CountryCode.pkCode]: CountryCodeNum.pkCode,
	[CountryCode.pwCode]: CountryCodeNum.pwCode,
	[CountryCode.psCode]: CountryCodeNum.psCode,
	[CountryCode.paCode]: CountryCodeNum.paCode,
	[CountryCode.pgCode]: CountryCodeNum.pgCode,
	[CountryCode.pyCode]: CountryCodeNum.pyCode,
	[CountryCode.peCode]: CountryCodeNum.peCode,
	[CountryCode.phCode]: CountryCodeNum.phCode,
	[CountryCode.plCode]: CountryCodeNum.plCode,
	[CountryCode.ptCode]: CountryCodeNum.ptCode,
	[CountryCode.prCode1]: CountryCodeNum.prCode1,
	[CountryCode.prCode2]: CountryCodeNum.prCode2,
	[CountryCode.qaCode]: CountryCodeNum.qaCode,
	[CountryCode.cgCode]: CountryCodeNum.cgCode,
	[CountryCode.reCode]: CountryCodeNum.reCode,
	[CountryCode.roCode]: CountryCodeNum.roCode,
	[CountryCode.ruCode]: CountryCodeNum.ruCode,
	[CountryCode.kzCode]: CountryCodeNum.kzCode,
	[CountryCode.rwCode]: CountryCodeNum.rwCode,
	[CountryCode.shCode]: CountryCodeNum.shCode,
	[CountryCode.knCode]: CountryCodeNum.knCode,
	[CountryCode.lcCode]: CountryCodeNum.lcCode,
	[CountryCode.mfCode]: CountryCodeNum.mfCode,
	[CountryCode.pmCode]: CountryCodeNum.pmCode,
	[CountryCode.vcCode]: CountryCodeNum.vcCode,
	[CountryCode.wsCode]: CountryCodeNum.wsCode,
	[CountryCode.smCode]: CountryCodeNum.smCode,
	[CountryCode.stCode]: CountryCodeNum.stCode,
	[CountryCode.saCode]: CountryCodeNum.saCode,
	[CountryCode.snCode]: CountryCodeNum.snCode,
	[CountryCode.rsCode]: CountryCodeNum.rsCode,
	[CountryCode.scCode]: CountryCodeNum.scCode,
	[CountryCode.slCode]: CountryCodeNum.slCode,
	[CountryCode.sxCode]: CountryCodeNum.sxCode,
	[CountryCode.skCode]: CountryCodeNum.skCode,
	[CountryCode.siCode]: CountryCodeNum.siCode,
	[CountryCode.sbCode]: CountryCodeNum.sbCode,
	[CountryCode.soCode]: CountryCodeNum.soCode,
	[CountryCode.zaCode]: CountryCodeNum.zaCode,
	[CountryCode.krCode]: CountryCodeNum.krCode,
	[CountryCode.ssCode]: CountryCodeNum.ssCode,
	[CountryCode.esCode]: CountryCodeNum.esCode,
	[CountryCode.lkCode]: CountryCodeNum.lkCode,
	[CountryCode.sdCode]: CountryCodeNum.sdCode,
	[CountryCode.srCode]: CountryCodeNum.srCode,
	[CountryCode.szCode]: CountryCodeNum.szCode,
	[CountryCode.seCode]: CountryCodeNum.seCode,
	[CountryCode.chCode]: CountryCodeNum.chCode,
	[CountryCode.syCode]: CountryCodeNum.syCode,
	[CountryCode.twCode]: CountryCodeNum.twCode,
	[CountryCode.tjCode]: CountryCodeNum.tjCode,
	[CountryCode.tzCode]: CountryCodeNum.tzCode,
	[CountryCode.thCode]: CountryCodeNum.thCode,
	[CountryCode.tgCode]: CountryCodeNum.tgCode,
	[CountryCode.tkCode]: CountryCodeNum.tkCode,
	[CountryCode.toCode]: CountryCodeNum.toCode,
	[CountryCode.ttCode]: CountryCodeNum.ttCode,
	[CountryCode.tnCode]: CountryCodeNum.tnCode,
	[CountryCode.trCode]: CountryCodeNum.trCode,
	[CountryCode.tmCode]: CountryCodeNum.tmCode,
	[CountryCode.tcCode]: CountryCodeNum.tcCode,
	[CountryCode.tvCode]: CountryCodeNum.tvCode,
	[CountryCode.viCode]: CountryCodeNum.viCode,
	[CountryCode.ugCode]: CountryCodeNum.ugCode,
	[CountryCode.uaCode]: CountryCodeNum.uaCode,
	[CountryCode.aeCode]: CountryCodeNum.aeCode,
	[CountryCode.uyCode]: CountryCodeNum.uyCode,
	[CountryCode.uzCode]: CountryCodeNum.uzCode,
	[CountryCode.vuCode]: CountryCodeNum.vuCode,
	[CountryCode.vaCode]: CountryCodeNum.vaCode,
	[CountryCode.veCode]: CountryCodeNum.veCode,
	[CountryCode.vnCode]: CountryCodeNum.vnCode,
	[CountryCode.wfCode]: CountryCodeNum.wfCode,
	[CountryCode.yeCode]: CountryCodeNum.yeCode,
	[CountryCode.zmCode]: CountryCodeNum.zmCode,
	[CountryCode.zwCode]: CountryCodeNum.zwCode
};

export const poundSterlingSymbol = '\u00A3';

export const emailValidationRegex = /^\S+@\S+\.\S+$/;

export const getQueryParam = (key: string) => {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	return urlParams.get(key);
};

export const getLocaleDateStringInIsoFormat = (value: Date) => {
	if (!hasValue(value)) {
		return null;
	}
	const year = value.getFullYear();
	const month = value.getMonth() + 1;
	const date = value.getDate();
	return `${year}-${padWithZeros(month, 2)}-${padWithZeros(date, 2)}`;
};

export const getLocaleDate = (isoDateString: string) => {
	if (!hasValue(isoDateString)) {
		return null;
	}
	const millisecondsInOneMinute = 60 * 1000;
	const date = new Date(isoDateString);
	const userTimezoneOffset = date.getTimezoneOffset() * millisecondsInOneMinute;
	return new Date(date.getTime() + userTimezoneOffset);
};

export const formatDate = (inputDate: string, formatString?: string): string => {
	try {
		const parsedDate = getLocaleDate(inputDate) ?? new Date(inputDate);
		const formattedDate = format(parsedDate, formatString ?? 'dd/MM/yyyy');
		return formattedDate;
	} catch {
		return '';
	}
};

export const getDayFromString = (stringDate: string) => {
	if (!hasValue(stringDate)) {
		return null;
	}

	if (stringDate.includes('-') && stringDate.split('-').length === 3) {
		try {
			const values = stringDate.split('-').map((value) => safeParseInt(value));
			return new Date(values[0], values[1] - 1, values[2], 0, 0, 0);
		} catch {
			return null;
		}
	}
	return null;
};

export const getLocaleDateFromFormatString = (dateString: string, formatString: string) => {
	if (!dateString) return null;

	return parse(dateString, formatString, new Date());
};

export const convertDate = (inputDate: string): string => {
	const [year, month, day] = inputDate.split('-');
	return `${day}/${month}/${year}`;
};

export const formatTimeStamp = (date: Date) => {
	return format(date, 'dd MMM yyyy HH:mm:ss');
};

export const formatTimeStampWithTimezone = (date: Date) => {
	return `${formatTimeStamp(date)} ${Intl.DateTimeFormat().resolvedOptions().timeZone}`;
};

export const validateMobile = (internationalNumber: string, newCountryCode: string = null) => {
	let errorMessage: string = null;
	const { countryCode, nationalNumber } = getPhoneNumberParts(internationalNumber, newCountryCode);
	const expectedLength = countryCodesToMobileNumberLengths[newCountryCode == null ? countryCode : newCountryCode];
	const currentCountryCode = newCountryCode == null ? countryCode : newCountryCode;
	// US Numbers don't have leading zeros, so this code needs to be modified to support them correctly.
	if (internationalNumber.length > 3 && nationalNumber.length > expectedLength) {
		errorMessage = `${currentCountryCode} mobile numbers must be ${expectedLength} digits without a leading zero or ${
			expectedLength + 1
		} with a leading zero.`;
	}
	return errorMessage;
};

export const getDefaultCountryCodeFromISOCode = (countryISOCode?: string): string => {
	if (hasValue(countryISOCode)) {
		const upperCode = countryISOCode.toUpperCase();
		if (upperCode === 'AU' || upperCode === 'AUS') return CountryCode.auCode;
		if (upperCode === 'IE' || upperCode === 'IRL') return CountryCode.ieCode;
		if (upperCode === 'GB' || upperCode === 'UK' || upperCode === 'GBR') return CountryCode.ukCode;
		if (upperCode === 'NZ' || upperCode === 'NZL') return CountryCode.nzCode;
		if (upperCode === 'SG' || upperCode === 'SGP') return CountryCode.sgCode;
		if (upperCode === 'CA' || upperCode === 'CAN') return CountryCode.caCode;
		if (upperCode === 'US' || upperCode === 'USA') return CountryCode.usCode;
		if ((Object.values(CountryCode) as string[]).includes(upperCode)) return upperCode;
		// Convert 3-letter ISO codes (e.g. 'GRL') to 2-letter (e.g. 'GL') for any country not handled above
		const twoLetterCode = countryCodeMap[upperCode];
		if (twoLetterCode && (Object.values(CountryCode) as string[]).includes(twoLetterCode)) return twoLetterCode;
	}
	return countryIsUk ? CountryCode.ukCode : CountryCode.auCode;
};

export const getPhoneNumberPartsForNoCountryCode = (internationalNumber: string, customerCountryISOCode?: string) => {
	if (hasValue(internationalNumber)) {
		let countryCodeNumLength = 3;
		const countryCodeNum = OldCountryCodeNumArray.find((num) => {
			return internationalNumber.startsWith(num);
		});
		const defaultCountryCode = getDefaultCountryCodeFromISOCode(customerCountryISOCode);
		const countryCode = isNonEmptyObject(countryCodeNum)
			? countryCodeNumsToCountryCodes[countryCodeNum]
			: defaultCountryCode;
		countryCodeNumLength = countryCodesToCountryCodeNums[countryCode].length;
		const nationalNumber = internationalNumber.slice(countryCodeNumLength);
		return { countryCode, nationalNumber };
	}
	const defaultCountryCode = getDefaultCountryCodeFromISOCode(customerCountryISOCode);
	return { countryCode: defaultCountryCode, nationalNumber: '' };
};

// the countryCode consists of two letter
export const getPhoneNumberParts = (
	internationalNumber: string,
	countryCode: string,
	customerCountryISOCode?: string
) => {
	if (hasValue(internationalNumber)) {
		let countryCodeNumLength = 3;
		let currentCountryCode = countryCode;
		if (!hasValue(currentCountryCode)) {
			let countryCodeNum = OldCountryCodeNumArray.find((num) => {
				return internationalNumber.startsWith(num);
			});
			if (!isNonEmptyObject(countryCodeNum)) {
				countryCodeNum = OldCountryCodeNumArray.find((num) => {
					const numWithoutPlus = num.replace('+', '');
					return internationalNumber.startsWith(numWithoutPlus);
				});
			}

			if (isNonEmptyObject(countryCodeNum)) {
				currentCountryCode = countryCodeNumsToCountryCodes[countryCodeNum];
			} else {
				currentCountryCode = getDefaultCountryCodeFromISOCode(customerCountryISOCode);
			}
		}
		const countryCodeNumWithPlus = countryCodesToCountryCodeNums[currentCountryCode];
		if (internationalNumber.startsWith('+')) {
			countryCodeNumLength = countryCodeNumWithPlus.length;
		} else {
			countryCodeNumLength = countryCodeNumWithPlus.replace('+', '').length;
		}
		const nationalNumber = internationalNumber.slice(countryCodeNumLength);
		return { countryCode: currentCountryCode, nationalNumber };
	}
	const defaultCountryCode = hasValue(countryCode)
		? getDefaultCountryCodeFromISOCode(countryCode)
		: getDefaultCountryCodeFromISOCode(customerCountryISOCode);
	return { countryCode: defaultCountryCode, nationalNumber: '' };
};

export const isNullOrEmptyString = (value: string) => value === null || value === '';

export const getIntFromQueryString = (queryString: string, name: string) => {
	const value = getUniqueQueryString(queryString, name);
	return hasValue(value) ? safeParseInt(value) : null;
};

export const getUniqueQueryString = (queryString: string, name: string) => {
	const queryStringHead = `${name}=`;
	const decodedString = decodeURIComponent(queryString);
	const stringWithoutQuestionMark = decodedString.startsWith('?') ? decodedString.slice(1) : decodedString;
	const queryStringArray = stringWithoutQuestionMark.split('&').filter((x) => x.startsWith(queryStringHead));
	if (queryStringArray.length === 0) {
		return '';
	}
	if (queryStringArray.length > 1) {
		throw new Error(`The query string can have at most one ${name}`);
	} else {
		return queryStringArray[0].slice(queryStringHead.length);
	}
};

export const sortDatesAscending = (a: Date, b: Date) => a.getTime() - b.getTime();

export const isObject = (o: unknown) => {
	return o === Object(o) && !isArray(o) && typeof o !== 'function';
};

const isArray = (a: unknown) => {
	return Array.isArray(a);
};

export const camelizeAll = (str: string) => {
	return str
		.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => (index === 0 ? word?.toLowerCase() : word.toUpperCase()))
		.replace(/\s+/g, '');
};

export const stopPropagationAndSetState =
	(setState: () => void, className = 'k-overlay') =>
	(e: React.MouseEvent<HTMLElement>) => {
		const { target } = e;
		e.stopPropagation();
		if ((target as any).className.split(' ').includes(className) && hasValue(setState)) setState();
	};

export const createQueryString = (dictionary: Record<string, string | string[] | number | number[] | boolean>) => {
	const strings = Object.keys(dictionary)
		.map((key) => {
			const value = dictionary[key];
			if (value === undefined || value === null) {
				return null;
			}
			// Casting the value to a string is a bit of hack because function signature of encodeURIComponent doesn't support
			// number[] when the fn does handle it.
			return `${key}=${encodeURIComponent(value as string)}`;
		})
		.filter((x) => x !== null);
	return strings.reduce((previous, current) => previous + (previous === '?' ? '' : '&') + current, '?');
};

export const hasValue = (value: unknown) => {
	return value !== undefined && value !== null && value !== '' && value !== 'undefined' && value !== 'null';
};

export const isNonEmptyObject = (value: unknown) => {
	return value !== undefined && value !== null && Object.entries(value).length > 0;
};

export const hasValueForAll = (dictionary: Record<string, unknown>) => {
	return Object.keys(dictionary).every((key) => hasValue(dictionary[key]));
};

const padWithZeros = (value: number, length: number) => {
	let valueString = value.toString();
	while (valueString.length < length) {
		valueString = `0${valueString}`;
	}
	return valueString;
};

// The following 2 functions are hacky to disable the form validation error message bubbles for Kendo dropdownlist.
// Code reference: https://www.telerik.com/blogs/building-html5-form-validation-bubble-replacements.
// TODO: We may use Custom React Hooks to customise validation error messages:
// https://github.com/Upmostly/custom-react-hooks-form-validation
export const setFormFieldErrorMessage = (field: HTMLElement & { validationMessage?: string }) => {
	const parent = field.closest('.k-form-field');
	if (parent !== null) {
		const errorMessages = parent?.querySelectorAll('.error');
		errorMessages.forEach((e: HTMLElement) => e.parentNode.removeChild(e));
		if (hasValue(field.validationMessage)) {
			parent.insertAdjacentHTML('beforeend', `<p class="error">${field.validationMessage}</p>`);
		}
	}
};

export const customiseErrorMessageForKendoField = () => {
	const inputs = document?.querySelectorAll('.k-combobox input, .k-dropdown select');
	inputs.forEach((input: HTMLElement) => {
		input.addEventListener(
			'invalid',
			(event: any) => {
				event.preventDefault();
				setFormFieldErrorMessage(input);
			},
			true
		);
	});
};

export const reportFormValidity = (formRef: React.RefObject<HTMLFormElement>) => {
	if (!formRef.current.reportValidity()) {
		return false;
	}
	return true;
};

export const trimLeadingSpace = (str: string) => {
	if (str === null) return str;
	return str.replace(/^\s+/g, '');
};

export const getValueOfDropdownListField = (value: string | boolean | Option<string>) => {
	return (value as Option<string>) && (value as Option<string>).value ? (value as Option<string>).value : value;
};

export const isOptionArray = <T>(array: T[]) => {
	return array?.length > 0 && isOption(array[0]);
};

export const getActualValue = <T>(value: T, data: T[]) => {
	if (!value) return value;
	return data && isOption(data[0]) && !isOption(value)
		? (data as unknown as Option<unknown>[]).find((x) => x.value === value)
		: value;
};

export const isOption = (value: unknown) => {
	return hasValue(value) && hasValue((value as Option<unknown>).text) && hasValue((value as Option<unknown>).value);
};

declare global {
	interface Window {
		MSStream: unknown;
	}
}

// https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
export const isAppleMobileOs = () => {
	return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

export const isIE = () => {
	const { userAgent } = window.navigator;
	const msie = userAgent.indexOf('MSIE ');
	if (msie > 0) return true;
	const trident = userAgent.indexOf('Trident/');
	if (trident > 0) return true;
	return false;
};

export const isEdge = () => {
	const { userAgent } = window.navigator;
	const edge = userAgent.indexOf('Edge');
	if (edge > 0) return true;
	return false;
};

export const isFireFox = () => {
	const { userAgent } = window.navigator;
	const fireFox = userAgent.indexOf('Firefox');
	if (fireFox > 0) return true;
	return false;
};

export const isOpera = () => {
	const { userAgent } = window.navigator;
	const opera = userAgent.indexOf('Opera');
	if (opera > 0) return true;
	return false;
};

// Author: Michael Zaporozhets & Tiesselune
// https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
export const isMobileOrTablet = () => {
	let check = false;
	((a) => {
		if (
			/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
				a
			) ||
			/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
				a.substr(0, 4)
			)
		)
			check = true;
	})(navigator.userAgent || navigator.vendor);
	return check;
};

// IE doesn't support object.values.
export const getObjectValues = (enums: Record<string, unknown>) => {
	return Object.keys(enums).map((item) => enums[item]);
};

export const redirectOrChangePage = (navigate: NavigateFunction, pageUrl: string) => {
	const redirectUrl = getQueryParam('redirectUrl');
	const url = redirectUrl ? decodeURIComponent(redirectUrl) : pageUrl;
	navigate(url);
};

export const safeParseInt = (value: string): number => {
	if (!hasValue(value)) {
		return null;
	}
	const number = parseInt(value, 10);
	if (Number.isNaN(number)) {
		throw new Error(`string value ${value} is NaN.`);
	}
	return number;
};

export const hasSupportedCamera = async () => {
	if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return false;

	// Firefox 38+, Microsoft Edge, and Chrome 44+ seems having support of enumerateDevices
	const devices = await navigator.mediaDevices.enumerateDevices();
	const supportedVideoDevice = devices.find((device) => device.kind === 'videoinput');
	return supportedVideoDevice !== undefined;
};

export const nestedArrayReducer = <T>(previous: T[], current: T[]) => previous.concat(current);

export const first = <T>(array: T[]): T => {
	if (array.length >= 1) {
		return array[0];
	}
	throw new Error('No elements in array.');
};

export const single = <T>(array: T[]): T => {
	const value = singleOrUndefined(array);
	// If the array contains just one element which is undefined, then an exception will be thrown here.
	if (value === undefined) {
		throw new Error('No elements in array.');
	} else {
		return value;
	}
};

export const singleOrUndefined = <T>(array: T[]): T => {
	if (array.length === 1) {
		return array[0];
	}
	if (array.length === 0) {
		return undefined;
	}
	throw new Error('More than one element in array.');
};

export const getAllInstancesOfRegexCapturingGroup = (regex: RegExp, value: string, matchIndex: number) => {
	const matches = [];
	// Attribution: https://stackoverflow.com/a/6323598/137996
	let match = null;
	do {
		match = regex.exec(value);
		if (hasValue(match)) {
			matches.push(match[matchIndex]);
		}
	} while (hasValue(match));
	return matches;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getNestedFieldValue = (object: any, fieldName: string): any => {
	const parts = fieldName.split('.');
	let currentObject: any = object;
	// eslint-disable-next-line no-restricted-syntax
	for (const part of parts) {
		if (currentObject === undefined || currentObject === null) {
			return undefined;
		}
		if (part.includes('[') && part.endsWith(']')) {
			// We only support one level of arrays.
			const [arrayName, indexStr] = part.replace(']', '').split('[');
			const array = currentObject[arrayName];
			if (Array.isArray(array)) {
				currentObject = array[safeParseInt(indexStr)];
			} else {
				currentObject = array;
			}
		} else {
			currentObject = currentObject[part];
		}
	}
	return currentObject;
};

export const setNestedFieldValue = (object: any, fieldName: string, value: unknown) => {
	const parts = fieldName.split('.');
	let currentObject = object;
	for (let i = 0; i < parts.length; i++) {
		if (currentObject === undefined) {
			throw new Error('Part of nested field path is undefined.');
		}

		const part = parts[i];
		if (i === parts.length - 1) {
			currentObject[part] = value;
		} else {
			currentObject = currentObject[part];
		}
	}
};

export const deepCopy = (object: unknown) => {
	return JSON.parse(JSON.stringify(object));
};

export const subtract = <T>(arrayOne: Array<T>, arrayTwo: Array<T>) => {
	return arrayOne.filter((x) => !arrayTwo.includes(x));
};

export const distinct = <T>(array: Array<T>) => {
	return Array.from(new Set(array));
};

export const forceTwoDigits = (value: string | number) => {
	return `0${value}`.slice(-2);
};

export const isClassObject = (value: unknown) => {
	return value !== null && typeof value === 'object' && !(value instanceof Date) && !Array.isArray(value);
};

export const getDateInDayMonthYearFormat = (date: Date) => {
	if (!hasValue(date)) return null;

	const dateStringArray = date.toDateString().split(' ');
	dateStringArray.shift();
	const month = dateStringArray.shift();
	const day = dateStringArray.shift();
	dateStringArray.unshift(month);
	dateStringArray.unshift(day);
	return dateStringArray.join(' ');
};

declare global {
	interface Navigator {
		msSaveBlob: (blob: Blob, fileName: string) => void;
	}
}

export const saveBase64File = (base64: string, title: string) => {
	// How strange that IE has a more palatable save file API than modern browsers.
	if (window.navigator.msSaveBlob) {
		window.navigator.msSaveBlob(b64toBlob(base64), title);
	} else {
		const a = document.createElement('a');
		a.download = title;
		a.href = `data:application/octet-stream;base64,${base64}`;
		a.target = '_blank';
		a.rel = 'noreferrer';
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}
};

export const makePluralTextOptional = (value: string) => {
	const { length } = value;
	return `${value.substr(0, length - 1)}(${value.charAt(value.length - 1)})`;
};

export const makeHyphenCase = (value: string) => {
	return value?.replace(/ /g, '-')?.toLowerCase();
};

export const removeHyphen = (value: string) => {
	return value?.replace(/-/g, ' ');
};

// Attribution: https://stackoverflow.com/a/16245768/1282237
const b64toBlob = (b64Data: string, contentType = '', sliceSize = 512) => {
	const byteCharacters = atob(b64Data);
	const byteArrays = [];

	for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
		const slice = byteCharacters.slice(offset, offset + sliceSize);

		const byteNumbers = [];
		for (let i = 0; i < slice.length; i++) {
			byteNumbers[i] = slice.charCodeAt(i);
		}

		const byteArray = new Uint8Array(byteNumbers);
		byteArrays.push(byteArray);
	}

	return new Blob(byteArrays, { type: contentType });
};

export const maxDate = (dateOne: Date, dateTwo: Date) => {
	return dateOne >= dateTwo ? dateOne : dateTwo;
};

// Attribution: https://stackoverflow.com/questions/43441856
export const scrollToRef = (ref: React.RefObject<HTMLElement>) =>
	window.scrollTo({
		left: 0,
		top: ref.current.offsetTop - ref.current.offsetHeight, // '- Height' is for possible page global header
		behavior: 'smooth'
	});

export const replaceElementInArray = <T>(array: T[], newElement: T, index: number) => {
	let newArray = null;
	if (hasValue(index) && index !== -1) {
		newArray = [...array];
		newArray[index] = newElement;
	} else {
		newArray = array.concat([newElement]);
	}
	return newArray;
};

export const spacedWordsToTitleCase = (value: string) => {
	let beginningOfNewWord = true;
	let newString = '';
	for (let i = 0; i < value.length; i++) {
		const char = value[i];
		if (beginningOfNewWord) {
			newString += char.toLocaleUpperCase();
			beginningOfNewWord = false;
		} else {
			newString += char;
		}

		if (char === ' ') {
			beginningOfNewWord = true;
		}
	}
	return newString;
};

export const getFormattedDate = (dateString: string, defaultValue = '') => {
	if (!dateString) return defaultValue;

	try {
		if (dateString.indexOf('---') !== -1) {
			const dateStr = String(dateString).replace(/---/g, '-01');
			return format(getLocaleDate(dateStr) ?? new Date(dateStr), 'MMM yyyy');
		}
		return format(getLocaleDate(dateString) ?? new Date(dateString), 'dd MMM yyyy');
	} catch {
		return defaultValue;
	}
};

export const divide = <T>(anArray: Array<T>, predicate: (element: T) => boolean): [Array<T>, Array<T>] => {
	const matching = anArray.filter(predicate);
	const notMatching = anArray.filter((e) => !predicate(e));
	return [matching, notMatching];
};

export const pixelsToNumber = (pixels: string) => safeParseInt(pixels.replace('px', ''));

export const isUniversalDateString = (value: string) => {
	const date = parse(value, 'yyyy-MM-dd', new Date());
	return !Number.isNaN(date.getTime());
};

export const deepEquals = <T>(valueOne: T, valueTwo: T) => {
	return JSON.stringify(valueOne) === JSON.stringify(valueTwo);
};

export const isImageOrPdfFile = (filename: string) => {
	return filename && filename.match(/.(jpg|jpeg|png|pdf)$/i);
};

export const isImageFile = (filename: string) => {
	return filename && filename.match(/.(jpg|jpeg|png)$/i);
};

export const getFileName = (filename: string) => {
	return filename.substring(0, filename.lastIndexOf('.'));
};

export const getCustomerById = (customer: Customer, id: number) => {
	let result = null;
	if (customer?.customerId === id) {
		return customer;
	}

	if (Array.isArray(customer?.childCustomer) && customer.childCustomer.length > 0) {
		customer.childCustomer.some((node) => {
			result = getCustomerById(node, id);
			return result;
		});
	}
	return result;
};

export const getCustomerPublicDisplayName = (rootCustomer: Customer, id: number): string | undefined => {
	const customer = getCustomerById(rootCustomer, id);
	return customer?.publicDisplayName || customer?.customerName;
};

export const getCustomerAncestorPath = (customer: Customer, id: number): Customer[] | null => {
	if (!customer) return null;
	if (customer.customerId === id) return [customer];

	let path: Customer[] | null = null;
	if (Array.isArray(customer.childCustomer)) {
		customer.childCustomer.some((child) => {
			path = getCustomerAncestorPath(child, id);
			return path;
		});
	}

	return path ? [...path, customer] : null;
};
export const flattenObject = (obj: any) => {
	const flattened: any = {};
	Object.keys(obj).forEach((key) => {
		const value = obj[key];
		if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
			const flattenedValue = flattenObject(value);
			Object.keys(flattenedValue).forEach((nestedKey) => {
				flattened[`${key}.${nestedKey}`] = flattenedValue[nestedKey];
			});
		} else {
			flattened[key] = value;
		}
	});
	return flattened;
};

// A replaced branding logo keeps the same blob name, and the blob is served without a Cache-Control header, so
// browsers and the CDN hold on to the previous image and a reload does not shift it. A per-render token makes
// the request unique, at the cost of the logo not being cached between renders.
export const withCacheBuster = (url: string): string => {
	if (!hasValue(url)) return url;
	return `${url}${url.includes('?') ? '&' : '?'}v=${Date.now()}`;
};

export const getVettingLogo = (): Logo => {
	const logo: Logo = {
		url: vettingLogoPng,
		fileName: 'vetting-logo.png',
		width: 300,
		height: 57
	};
	return logo;
};

export const hasVettingLogo = (logo: Logo) => {
	if (!hasValue(logo)) {
		return false;
	}
	return logo.fileName === getVettingLogo().fileName;
};

export const validateMedicareNumber = (value: string | null): boolean => {
	if (value === null) {
		return false;
	}

	const medicareNo = value.replace(/[^\d]/g, '');
	if (medicareNo.length === 10 && (parseInt(medicareNo[0], 10) >= 2 || parseInt(medicareNo[0], 10) <= 6)) {
		// Test leading digit and checksum
		const basePart = medicareNo.slice(0, 8);
		const checkDigit = medicareNo.slice(8, 9);

		let sum = 0;
		const weights = [1, 3, 7, 9, 1, 3, 7, 9];

		for (let position = 0; position < weights.length; position++) {
			sum += parseInt(basePart[position], 10) * weights[position];
		}
		return sum % 10 === parseInt(checkDigit, 10);
	}
	return false;
};

export const areArraysEqual = (arr1: string[], arr2: string[]) => {
	return arr1.length === arr2.length && arr1.every((value) => arr2.includes(value));
};

export const areObjectsEqual = (obj1: any, obj2: any): boolean => {
	const keys1 = Object.keys(obj1);
	const keys2 = Object.keys(obj2);

	if (keys1.length !== keys2.length) {
		return false;
	}

	return keys1.every((key) => {
		const value1 = obj1[key];
		const value2 = obj2[key];

		if (typeof value1 === 'object' && typeof value2 === 'object') {
			return areObjectsEqual(value1, value2);
		}

		return value1 === value2;
	});
};

export const getFileExtension = (filename: string): string | undefined => {
	const lastDotIndex = filename.lastIndexOf('.');
	if (lastDotIndex !== -1) {
		return filename.slice(lastDotIndex + 1)?.toLowerCase();
	}
	return undefined;
};

const imageExtensions = ['jpg', 'jpeg', 'png', 'webp'];

// A file's extension is only a label: it is not checked against the bytes, so an image saved from a web page
// often arrives as AVIF (or another format) still named ".png". The back end decodes with SkiaSharp, which
// cannot read those, so the upload failed with no usable message even though the file opened fine everywhere
// else. Re-encoding through a canvas fixes that: the browser decodes whatever it can display and we always
// hand the back end a real PNG, whose bytes, name and content type finally agree.
const normaliseImageFile = async (rawFile: File, fileName: string): Promise<File> => {
	const bitmap = await createImageBitmap(rawFile);

	try {
		const maxDimension = 1000;
		const scale = Math.min(1, maxDimension / Math.max(bitmap.width, bitmap.height));
		const canvas = document.createElement('canvas');
		canvas.width = Math.max(1, Math.round(bitmap.width * scale));
		canvas.height = Math.max(1, Math.round(bitmap.height * scale));

		const context = canvas.getContext('2d');
		if (!context) {
			throw new Error('Could not get a 2d canvas context.');
		}
		context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);

		// PNG rather than JPEG so a logo's transparency survives the round trip.
		const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/png'));
		if (!blob) {
			throw new Error('Could not read the image back from the canvas.');
		}

		const nameWithoutExtension = fileName.replace(/\.[^.]*$/, '');
		return new File([blob], `${nameWithoutExtension}.png`, { type: 'image/png', lastModified: Date.now() });
	} finally {
		bitmap.close();
	}
};

export const getCompressedFile = async (file: UploadFileInfo) => {
	const rawFile = file.getRawFile();
	const fileExtension = getFileExtension(file.name);

	// Documents such as PDFs are uploaded untouched; only images go through the canvas.
	if (!imageExtensions.includes(fileExtension)) {
		return rawFile;
	}

	try {
		return await normaliseImageFile(rawFile, file.name);
	} catch {
		// The browser could not decode it either, so send the original bytes and let the back end reject it
		// with a message naming the supported formats.
		return rawFile;
	}
};

type DateRange = {
	endDate: string | null;
	startDate: string | null;
};

export const getStartAndEndDate = (timeperiod: string): DateRange => {
	const now = new Date();
	const formatTimePeriod = (date: Date) => date.toISOString().split('T')[0];

	switch (timeperiod) {
		case 'Last 24 Hours':
			return {
				endDate: formatTimePeriod(now),
				startDate: formatTimePeriod(new Date(now.getTime() - 24 * 60 * 60 * 1000))
			};
		case 'Last 7 Days':
			return {
				endDate: formatTimePeriod(now),
				startDate: formatTimePeriod(new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000))
			};
		case 'Last 14 Days':
			return {
				endDate: formatTimePeriod(now),
				startDate: formatTimePeriod(new Date(now.getTime() - 14 * 24 * 60 * 60 * 1000))
			};
		case 'Last 30 Days':
			return {
				endDate: formatTimePeriod(now),
				startDate: formatTimePeriod(new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000))
			};
		case 'Last 60 Days':
			return {
				endDate: formatTimePeriod(now),
				startDate: formatTimePeriod(new Date(now.getTime() - 60 * 24 * 60 * 60 * 1000))
			};
		default:
			return { endDate: null, startDate: null };
	}
};

interface FilteredReportWorkflow {
	status?: string;
	outcome?: string;
	lastEventDate?: Date | null;
	createdDate?: Date | null;
	submissionDate?: Date | null;
	workflowServiceName?: string;
	workflowTypeCode?: string;
	checkCompletedDate?: Date | null;
	turnaroundTimeInMinutes?: number | null;
	count?: number;
}

interface ValidWorkflow {
	workflowServiceName: string;
	recordCount: number;
}

export function groupAndCountWorkflows(workflows: ReportWorkflows[], groupBy: string): FilteredReportWorkflow[] {
	if (groupBy === 'CheckStatus') {
		const grouped = workflows.reduce((acc, workflow) => {
			if (!acc[workflow.workflowTypeCode]) {
				acc[workflow.workflowTypeCode] = 0;
			}
			acc[workflow.workflowTypeCode]++;
			return acc;
		}, {} as Record<string, number>);
		const filteredReportWorkflows: FilteredReportWorkflow[] = Object.entries(grouped).map(
			([workflowTypeCode, count]) => ({
				workflowTypeCode,
				count
			})
		);

		return filteredReportWorkflows;
	}
	if (groupBy === 'CheckType') {
		const grouped = workflows.reduce((acc, workflow) => {
			if (!acc[workflow.status]) {
				acc[workflow.status] = 0;
			}
			acc[workflow.status]++;
			return acc;
		}, {} as Record<string, number>);

		const filteredReportWorkflows: FilteredReportWorkflow[] = Object.entries(grouped).map(([status, count]) => ({
			status,
			count
		}));

		return filteredReportWorkflows;
	}
	const groupedWorkflows = workflows.reduce((acc, workflow) => {
		if (!acc[workflow.workflowTypeCode]) {
			acc[workflow.workflowTypeCode] = [];
		}
		acc[workflow.workflowTypeCode].push(workflow);
		return acc;
	}, {} as Record<string, ReportWorkflows[]>);

	const validWorkflows: ValidWorkflow[] = Object.entries(groupedWorkflows)
		.map(([workflowTypeCode, group]) => ({
			workflowServiceName: workflowTypeCode,
			recordCount: group.filter(
				(w) => w.checkCompletedDate && w.lastEventDate && w.lastEventDate < w.checkCompletedDate
			).length
		}))
		.filter((x) => x.recordCount > 0);

	const filteredReportWorkflows: FilteredReportWorkflow[] = Object.entries(groupedWorkflows).map(([, group]) =>
		createAvgFilteredReportWorkflow(group, validWorkflows)
	);

	return filteredReportWorkflows;
}

const createAvgFilteredReportWorkflow = (
	group: ReportWorkflows[],
	validWorkflows: ValidWorkflow[]
): FilteredReportWorkflow => {
	const totalCount = group.reduce(
		(sum, workflow) => sum + getTurnAroundTime(workflow.checkCompletedDate, workflow.createdDate),
		0
	);

	const validWorkflow = validWorkflows.find((vw) => vw.workflowServiceName === group[0].workflowTypeCode);
	const recordCount = validWorkflow ? validWorkflow.recordCount : 1;

	return {
		workflowServiceName: group[0].workflowTypeCode,
		count: totalCount / recordCount
	};
};

const getTurnAroundTime = (checkCompletedDate: Date | null, submissionDate: Date | null): number => {
	if (checkCompletedDate && submissionDate) {
		return checkCompletedDate.getTime() - submissionDate.getTime() / (1000 * 60);
	}
	return 0;
};

export const capitalizeFirstChar = (str: string): string => str.replace(/^(.)/, (match, p1) => p1.toUpperCase());
